@if(currentStepIndex !== DocumentStepEnum.AsicResponse) {
  <div class="generate-documents-header">
    <div class="button-container-default">
      @if (currentStepIndex === DocumentStepEnum.GenerateDocuments) {
        <app-button
          [text]="'Save and Complete Later'"
          [btnColor]="'white'"
          [loading]="loading || saveLoading()"
          [isDisabled]="loading || patchLoading() || saveLoading()"
          (clickBtn)="save()"
        ></app-button>
      }

      @if(currentStepIndex === DocumentStepEnum.SignDocuments) {
        @if(displayLodgeNowBtn) {
          <app-button
            [text]="'Lodge now'"
            [loading]="loading || patchLoading() || saveLoading() || lodgeNowLoading()"
            [isDisabled]="loading || patchLoading() || saveLoading() || sendSignLoading() || lodgeNowLoading()"
            (clickBtn)="onLodgeDocumentNow()"
          ></app-button>
        }

        @if(showSendEmailBtn()) {
          <app-button
            [text]="'Send email'"
            [loading]="loading || patchLoading() || sendSignLoading()"
            [iconLast]="true"
            [iconClass]="'icon ic-arrow-right'"
            [isDisabled]="loading || patchLoading() || disabledHeaderBtn() || sendSignLoading()"
            (clickBtn)="confirm()"
          ></app-button>
        } @else if(showSendPaperBtn()) {
          <app-button
            [text]="document?.documentSigning?.signingStatus === SigningStatus.Signed ? (showNotLodgedConfirmBtn() ? 'Confirm Changes' : 'Lodge') : 'Confirm Signing'"
            [loading]="loading || patchLoading() || sendSignLoading() || lodgeNowLoading()"
            [iconLast]="true"
            [iconClass]="'icon ic-arrow-right'"
            [isDisabled]="loading || patchLoading() || disabledHeaderBtn() || sendSignLoading() || lodgeNowLoading()"
            (clickBtn)="document?.documentSigning?.signingStatus === SigningStatus.Signed ? (showNotLodgedConfirmBtn() ? confirmNotLodged() : confirm()) : paperSign()"
          ></app-button>
        } @else {
          <app-button
            [text]="showVoidEnvelope() ? (showNotLodgedConfirmBtn() ? 'Confirm Changes' : 'Lodge') : 'Send for E-Sign'"
            [loading]="loading || patchLoading() || sendSignLoading() || lodgeNowLoading()"
            [iconLast]="true"
            [iconClass]="'icon ic-arrow-right'"
            [isDisabled]="loading || patchLoading() || disabledHeaderBtn() || sendSignLoading() || lodgeNowLoading()"
            (clickBtn)="showVoidEnvelope() ? (showNotLodgedConfirmBtn() ? confirmNotLodged() : confirm()) : sign()"
          ></app-button>
        }
      } @else {
        <app-button
          [text]="confirmBtnName"
          [loading]="loading || patchLoading()"
          [iconLast]="true"
          [iconClass]="'icon ic-arrow-right'"
          [isDisabled]="loading || patchLoading() || disabledHeaderBtn()"
          (clickBtn)="confirm()"
        ></app-button>
      }
    </div>

    <div class="button-container-alternate">
      @if (currentStepIndex === DocumentStepEnum.GenerateDocuments) {
        <app-tooltip [customContent]="true">
          <app-button
            container="body"
            [ngbTooltip]="'Save and Complete Later'"
            [placement]="'top'"
            [tooltipClass]="'tooltip-info width-auto'"
            [disableTooltip]="loading || patchLoading() || saveLoading()"
            [iconClass]="'icon ic-documents'"
            [btnColor]="'white'"
            [loading]="loading || saveLoading()"
            [isDisabled]="loading || patchLoading() || saveLoading()"
            (clickBtn)="save()"
          ></app-button>
        </app-tooltip>
      }

      <app-tooltip [customContent]="true">
        @if(currentStepIndex === DocumentStepEnum.SignDocuments) {
          @if(displayLodgeNowBtn) {
            <app-button
              class="mr-10"
              container="body"
              [ngbTooltip]="'Lodge now'"
              [placement]="'top'"
              [tooltipClass]="'tooltip-info width-auto'"
              [disableTooltip]="loading || patchLoading() || saveLoading() || sendSignLoading() || lodgeNowLoading()"
              [loading]="loading || patchLoading() || saveLoading() || lodgeNowLoading()"
              [isDisabled]="loading || patchLoading() || saveLoading() || sendSignLoading() || lodgeNowLoading()"
              [iconClass]="'icon ic-clock'"
              (clickBtn)="onLodgeDocumentNow()"
            ></app-button>
          }

          @if(showSendEmailBtn()) {
            <app-button
              container="body"
              [ngbTooltip]="'Send email'"
              [placement]="'top'"
              [tooltipClass]="'tooltip-info width-auto'"
              [disableTooltip]="loading || patchLoading() || saveLoading() || disabledHeaderBtn() || sendSignLoading()"
              [loading]="loading || patchLoading() || sendSignLoading() || lodgeNowLoading()"
              [iconLast]="true"
              [iconClass]="'icon ic-arrow-right'"
              [isDisabled]="loading || patchLoading() || disabledHeaderBtn() || sendSignLoading() || lodgeNowLoading()"
              (clickBtn)="confirm()"
            ></app-button>
          } @else if(showSendPaperBtn()) {
            <app-button
              container="body"
              [ngbTooltip]="document?.documentSigning?.signingStatus === SigningStatus.Signed ? (showNotLodgedConfirmBtn() ? 'Confirm Changes' : 'Lodge') : 'Confirm Signing'"
              [placement]="'top'"
              [tooltipClass]="'tooltip-info width-auto'"
              [disableTooltip]="loading || patchLoading() || saveLoading() || disabledHeaderBtn() || sendSignLoading() || lodgeNowLoading()"
              [loading]="loading || patchLoading() || sendSignLoading() || lodgeNowLoading()"
              [iconLast]="true"
              [iconClass]="'icon ic-arrow-right'"
              [isDisabled]="loading || patchLoading() || disabledHeaderBtn() || sendSignLoading() || lodgeNowLoading()"
              (clickBtn)="document?.documentSigning?.signingStatus === SigningStatus.Signed ? (showNotLodgedConfirmBtn() ? confirmNotLodged() : confirm()) : paperSign()"
            ></app-button>
          } @else {
            <app-button
              container="body"
              [ngbTooltip]="showVoidEnvelope() ? (showNotLodgedConfirmBtn() ? 'Confirm Changes' : 'Lodge') : 'Send for E-Sign'"
              [placement]="'top'"
              [tooltipClass]="'tooltip-info width-auto'"
              [disableTooltip]="loading || patchLoading() || saveLoading() || disabledHeaderBtn() || sendSignLoading() || lodgeNowLoading()"
              [loading]="loading || patchLoading() || sendSignLoading() || lodgeNowLoading()"
              [iconLast]="true"
              [iconClass]="'icon ic-arrow-right'"
              [isDisabled]="loading || patchLoading() || disabledHeaderBtn() || sendSignLoading() || lodgeNowLoading()"
              (clickBtn)="showVoidEnvelope() ? (showNotLodgedConfirmBtn() ? confirmNotLodged() : confirm()) : sign()"
            ></app-button>
          }
        } @else {
          <app-button
            container="body"
            [ngbTooltip]="'Next step'"
            [placement]="'top'"
            [tooltipClass]="'tooltip-info width-auto'"
            [disableTooltip]="loading || patchLoading() || saveLoading() || disabledHeaderBtn() || sendSignLoading()"
            [loading]="loading || patchLoading() || sendSignLoading()"
            [iconLast]="true"
            [iconClass]="'icon ic-arrow-right'"
            [isDisabled]="loading || patchLoading() || disabledHeaderBtn() || sendSignLoading()"
            (clickBtn)="confirm()"
          ></app-button>
        }
      </app-tooltip>
    </div>
  </div>
}
